module.exports = __webpack_public_path__ + "img/首页轮播图2.a84faa49.jpg";